/**
 * Place any jQuery/helper plugins in here.
 */
$(function () {
    /**
     * Checkbox tree for permission selecting
     */
    let permissionTree = $('.permission-tree :checkbox');

    permissionTree.on('click change', function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        } else {
            $(this).siblings('ul').find('input[type="checkbox"]').removeAttr('checked').removeAttr('disabled');
        }
    });

    permissionTree.each(function () {
        if ($(this).is(':checked')) {
            $(this).siblings('ul').find('input[type="checkbox"]').attr('checked', true).attr('disabled', true);
        }
    });

    /**
     * Disable submit inputs in the given form
     *
     * @param form
     */
    function disableSubmitButtons(form) {
        form.find('input[type="submit"]').attr('disabled', true);
        form.find('button[type="submit"]').attr('disabled', true);
    }

    /**
     * Enable the submit inputs in a given form
     *
     * @param form
     */
    function enableSubmitButtons(form) {
        form.find('input[type="submit"]').removeAttr('disabled');
        form.find('button[type="submit"]').removeAttr('disabled');
    }

    /**
     * Disable all submit buttons once clicked
     */
    $('form').submit(function () {
        disableSubmitButtons($(this));
        return true;
    });

    /**
     * Add a confirmation to a delete button/form
     */
    $('body').on('submit', 'form[name=delete-item]', function (e) {
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure you want to delete this item?',
            showCancelButton: true,
            confirmButtonText: 'Confirm Delete',
            cancelButtonText: 'Cancel',
            icon: 'warning'
        }).then((result) => {
            if (result.value) {
                this.submit()
            } else {
                enableSubmitButtons($(this));
            }
        });
    })
            .on('submit', 'form[name=confirm-item]', function (e) {
                e.preventDefault();

                Swal.fire({
                    title: 'Are you sure you want to do this?',
                    showCancelButton: true,
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    icon: 'warning'
                }).then((result) => {
                    if (result.value) {
                        this.submit()
                    } else {
                        enableSubmitButtons($(this));
                    }
                });
            })
            .on('click', 'a[name=confirm-item]', function (e) {
                /**
                 * Add an 'are you sure' pop-up to any button/link
                 */
                e.preventDefault();

                Swal.fire({
                    title: 'Are you sure you want to do this?',
                    showCancelButton: true,
                    confirmButtonText: 'Continue',
                    cancelButtonText: 'Cancel',
                    icon: 'info',
                }).then((result) => {
                    result.value && window.location.assign($(this).attr('href'));
                });
            });

    // Remember tab on page load
    $('a[data-toggle="tab"], a[data-toggle="pill"]').on('shown.bs.tab', function (e) {
        let hash = $(e.target).attr('href');
        history.pushState ? history.pushState(null, null, hash) : location.hash = hash;
    });

    let hash = window.location.hash;
    if (hash) {
        $('.nav-link[href="' + hash + '"]').tab('show');
    }

    // Enable tooltips everywhere
    $('[data-toggle="tooltip"]').tooltip();

    // Mostra la richiesta conferma per cestinare gli utenti.



    $('.c-sidebar').on('mouseenter', function (e) {
        e.preventDefault();
        el = $(e.currentTarget);
        el.addClass("c-sidebar-hovered");
    }).on('mouseleave', function (e) {
        e.preventDefault();
        el = $(e.currentTarget);
        el.removeClass("c-sidebar-hovered");
    });

    $('[type="password"]').each(function () {
        var input = $(this);
        var eye_btn = $(this).parent().find('.input-group-text');
        eye_btn.css('cursor', 'pointer').addClass('input-password-hide');
        eye_btn.on('click', function () {
            if (eye_btn.hasClass('input-password-hide')) {
                eye_btn.removeClass('input-password-hide').addClass('input-password-show');
                eye_btn.find('.fa').removeClass('fa-eye').addClass('fa-eye-slash')
                input.attr('type', 'text');
            } else {
                eye_btn.removeClass('input-password-show').addClass('input-password-hide');
                eye_btn.find('.fa').removeClass('fa-eye-slash').addClass('fa-eye')
                input.attr('type', 'password');
            }
        });
    });

    /*
     
     Chart.register({
     id: 'customTooltip',
     beforeDraw: (chart, args, options) => {
     const context = chart;
     // Tooltip Element
     let tooltipEl = document.getElementById('chartjs-tooltip');
     
     // Create element on first render
     if (!tooltipEl) {
     tooltipEl = document.createElement('div');
     tooltipEl.id = 'chartjs-tooltip';
     tooltipEl.innerHTML = '<table></table>';
     document.body.appendChild(tooltipEl);
     }
     
     tooltipEl.classList.add('chartTooltip');
     
     // Hide if no tooltip
     const tooltipModel = chart.tooltip;
     
     // Set caret Position
     tooltipEl.classList.remove('above', 'below', 'no-transform');
     if (tooltipModel.yAlign) {
     tooltipEl.classList.add(tooltipModel.yAlign);
     } else {
     tooltipEl.classList.add('no-transform');
     }
     
     function getBody(bodyItem) {
     return bodyItem.lines;
     }
     
     // Set Text
     if (tooltipModel.body) {
     const titleLines = tooltipModel.title || [];
     const bodyLines = tooltipModel.body.map(getBody);
     
     let innerHtml = '<thead>';
     
     titleLines.forEach(function (title) {
     innerHtml += '<tr><th>' + title + '</th></tr>';
     });
     innerHtml += '</thead><tbody>';
     
     bodyLines.forEach(function (body, i) {
     const colors = tooltipModel.labelColors[i];
     let style = 'background:' + colors.backgroundColor;
     style += '; border-color:' + colors.borderColor;
     style += '; border-width: 2px';
     const span = '<span style="' + style + '"></span>';
     innerHtml += '<tr><td>' + span + body + '</td></tr>';
     });
     innerHtml += '</tbody>';
     
     let tableRoot = tooltipEl.querySelector('table');
     tableRoot.innerHTML = innerHtml;
     }
     
     const position = chart.canvas.getBoundingClientRect();
     // Display, position, and set styles for font
     tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
     tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
     
     //console.log(tooltipModel.opacity);
     if (tooltipModel.opacity === 0) {
     //    tooltipEl.style.opacity = 0;
     return;
     } else {
     tooltipEl.style.opacity = 1;
     tooltipModel.opacity = 0;
     }
     
     
     }
     });
     */




    /*
     $('body').on('submit', 'form[name=trash-item]', function(e) {
     e.preventDefault();
     
     Swal.fire({
     title: 'Vuoi spostare nel cestino questa richiest?',
     showCancelButton: true,
     confirmButtonText: 'Confermo',
     cancelButtonText: 'Annulla',
     icon: 'warning'
     }).then((result) => {
     if (result.value) {
     this.submit();
     } else {
     enableSubmitButtons($(this));
     }
     });
     });*/

});


